import { getSearchParams } from './getSearchParams'

export const isPrivate = () => {
  if (getSearchParams()?.private) {
    return true
  }
  return false
}
